import { Question } from './question.model';

// Without this dynamic parameter AOT compiling will fail.
// @see https://angular.io/guide/angular-compiler-options#strictmetadataemit
// @dynamic
export class GapMatchQuestion extends Question {
  public static fromDto(dto: any): GapMatchQuestion {
    const question: GapMatchQuestion = new GapMatchQuestion();
    Question.mapBaseProperties(question, dto);
    return question;
  }
}
